// Download Monitor Plugin

; (function (jQuery) {

	"use strict";

	function Download_Monitor() {

		var fn = {

			init: function ()
			{
				jQuery('.downloads__header').on('click', fn.toggleDownloads);
			},

			toggleDownloads: function()
			{
				const cat = jQuery(this);
				cat.next('ul').slideToggle(500);
				cat.toggleClass('downloads__header--open');
				cat.children('.less').toggle(500);
				cat.children('.more').toggle(500);
			}

		}

		jQuery(fn.init);

	}

	new Download_Monitor();

})(jQuery);